/* Export containers */
// export * from './containers/'
export * from './containers/user-details.component';
/* Export components */
export * from './components/create-user/create-user.component';
export * from './components/questionary/questionary.component';
export * from './components/dependant-details/dependant-details.component';
export * from './components/annuitant-details/annuitant-details.component';
export * from './components/dependant-healthandlifestyle/dependant-healthandlifestyle.component';
export * from './components/dependant-medical-conditions/dependant-medical-conditions.component';
export * from './components/guidance-and-advice/guidance-and-advice.component';
/* Export config */
export * from './config/user-data.config';

/* Export module */
export * from './containers/user-details.module';
